import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './hooks/useAuth'
import { ThemeProvider } from './hooks/useTheme'
import App from './App.jsx'
import { markTitle } from './components/environment'
import './styles/index.css'

// Initialize i18n
import './i18n'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// HP-60: the tab names the environment (Prod, UAT, SIT).
markTitle()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* VH-133: ThemeProvider sits inside AuthProvider because the stored
            preference lives on the user profile — it needs the user to
            reconcile against, and must re-run when the user changes. */}
        <AuthProvider>
          <ThemeProvider>
            <App />
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                // Toasts are global chrome and previously hardcoded a dark
                // card (#363636) that looked pasted-on in light mode. Driving
                // them from the same tokens as everything else means they
                // follow the theme without this file knowing which one is on.
                style: {
                  background: 'var(--vh-surface-container)',
                  color: 'var(--vh-on-surface)',
                  border: '1px solid var(--vh-outline-variant)',
                },
              }}
            />
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)